import { render, staticRenderFns } from "./CarteiraCadastroGruposApp.vue?vue&type=template&id=a6d790d4&scoped=true"
import script from "./CarteiraCadastroGruposApp.vue?vue&type=script&lang=js"
export * from "./CarteiraCadastroGruposApp.vue?vue&type=script&lang=js"
import style0 from "./CarteiraCadastroGruposApp.vue?vue&type=style&index=0&id=a6d790d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d790d4",
  null
  
)

export default component.exports